export {default as extendedScpService} from './extendedScpService';
